module.exports = __webpack_public_path__ + "static/media/car_hv.18acd808.png";